export function maskCPF(cpf: string): string {
  return cpf
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

export function maskZipCode(cep: string): string {
  return cep.replace(/\D/g, '').replace(/(\d{5})(\d{3})$/, '$1-$2')
}

export function maskCNPJ(cnpj: string) {
  const CNPJ_PATTERN = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/

  return cnpj?.replace(CNPJ_PATTERN, '$1.$2.$3/$4-$5') ?? ''
}

export function maskPhone(phone: string): string {
  return phone
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})(\d)?$/, '$1-$2')
}

export function maskDate(date: string): string {
  return date
    .slice(0, 10)
    .replace(/\D/g, '')
    .replace(/^(\d{0,2})(\d{0,2})?(\d{0,4})?/, (_, p1, p2, p3) => {
      let result = ''
      if (p1) result += p1
      if (p2) result += `-${p2}`
      if (p3) result += `-${p3}`
      return result
    })
}
